import Size from "../../Resolution/WindowSize";
import PixelDensity from "../../Resolution/PixelDensity";
import Zoom from "../../Zoom/Zoom";


function MiddleColumns() {
    return (
        <div className="middle-columns">
            <div className="middle-columns__wrapper">
                <div className="column"><Size/></div>
                <div className="column"><Zoom/></div>
                <div className="column"><PixelDensity/></div>
            </div>
        </div>
    );
}

export default MiddleColumns;